<div class="ui modal explanation_modal_class " id="explanation_modal" style="position: absolute;left: 70%;bottom:70%;">
    <div class="ui card " id="explanation_uicard">
        <div class="content" style="height:30px">
            <span style="float:left;color:black;margin-top:10px;font-weight:bold">{{"explanation" | t}}</span>

            <button class="circular ui icon button" style="float:right;background-color: white;border: 1px solid;" (click)="ExitExplanationModal()">
                <i class="remove link icon"></i>
            </button>
        </div>

        <div class="content explanation_list" >
            <div>

                <table id="explanationmodal_table">
                    <tr class="explanationmodal_tr" style="background-color:#115512;">
                        <td style="width:20%;align-content:center">

                            <button class="circular ui icon button explanation_buttons" style="border-color:white;background-color:transparent"><span style="color:white">1,5</span></button> &nbsp;&nbsp;

                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_match_has_started_or_will_start_shortly.Bets_can_be_placed." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#064fa5;">
                        <td style="width:20%;align-content:center">

                            <button class="circular ui icon button explanation_buttons" style="border-color:white;background-color:transparent"><span style="color:white">1,5</span></button> &nbsp;&nbsp;

                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_match_is_at_half-time.Bets_can_be_placed." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <button class="circular ui icon button explanation_buttons" style="border-color:#464646;background-color:#111111"><span style="color:white">1,5</span></button> &nbsp;&nbsp;

                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_match_has_not_started_yet.Bets_can_be_placed." | t }}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <button class="circular ui icon button explanation_buttons" style="border-color:yellow;background-color:transparent" ><span style="color:white">1,5</span></button> &nbsp;&nbsp;

                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_odds_have_been_updated" | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <button class="circular ui icon button explanation_buttons" style="border-color:white;background-color:transparent"><span style="color:white">+5</span></button> &nbsp;&nbsp;

                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Display_of_side_bets." | t }}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <button class="mini ui green button" style="position:relative;left:8px;cursor:default"><span>L</span></button> &nbsp;&nbsp;

                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Bets_can_be_placed_now_and_throughout_the_complete_match." | t }}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <button class="mini ui red button" style="position:relative;left:8px;cursor:default"><span>2</span></button> &nbsp;&nbsp;

                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Indicates_the_number_of_red_cards_issued_against_a_team." | t }}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">RZ-1</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_home_team_score_more_goals_after_the_bet_is_placed." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">RZ-X</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Both_teams_score_the_same_number_of_goals_after_the_bet_is_placed." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">RZ-2</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_guest_team_scored_more_goals_after_the_bet_is_placed." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">   T</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Goal_line_for_the_Over/Under_bet._Every_gol_scored_counts." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">Uber</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"More_goals/points_scored_than_specified_in_the_goal_line(G).Every_goal/point_scored_counts." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">Unter</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Less_goals/points_scored_than_specified_in_the_goal_line(G).Every_goal/point_scored_counts." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">   1</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_home_team_scored_more_goals/points_at_the_end_of_the_full_time." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">   X</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Both_teams_score_the_same_number_of_goals/points_after_the_end_of_the_full_time." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">   2</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"The_guess_team_scored_more_goals/points_at_the_end_of_the_full_time." | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">(N)</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Match_at_a_neutral_location" | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">(R)</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Reverse_team" | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">(F)</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Woman_team" | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#111111;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">(J)</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Junior_team" | t}}</span>
                        </td>

                    </tr>
                    <tr class="explanationmodal_tr" style="background-color:#333333;">
                        <td style="width:20%;align-content:center">

                            <span class="explanation1span">(U)</span>
                        </td>
                        <td style="width:80%">
                            <span class="explanation_span">{{"Class_of_Age(e.g_U19)" | t}}</span>
                        </td>

                    </tr>
                </table>


            </div>





        </div>



        <div class="extra content" id="sporttopleaguesmodal_buttons">
            <div class="large ui buttons">
                <button class="large ui button terminalButton" id="explanationmodal_downbutton" (click)="ExplanationdownScroll()"><i class="caret down icon " style="position:relative;left:5px;"></i></button>
                <button class="large ui button terminalButton" id="explanationmodal_downbutton" (click)="ExplanationupScroll()"><i class="caret up icon" style="position:relative;left:5px;"></i></button>

            </div>


        </div>

    </div>
</div>
<style>
    .explanation1span {
        font-size: 13px;
        font-family: initial;
        color: white;
        position: relative;
        margin-left: 15px;
        cursor:default;
    }

    .explanation_span {
        font-size: 11px;
        font-family: inherit;
        color: white;
        cursor:default;
    }

    .explanation_buttons {
        float: left;
        background-color: transparent;
        border: 1px solid;
        color: white;
        width: 30px;
        height: 30px;
        text-align: center;
        font-size: 9px;
        cursor: default;
        position: relative;
        left: 10px;
    }

    .explanation_list {
        height: 300px;
        overflow-x: auto;
        padding-left: 7px;
        padding-right: 7px;
        padding-bottom: 0px;
        padding-top: 0px;
        height: 520px;
    }





    .explanationmodal_tr {
        height: 50px;
    }



    #explanation_uicard {
        height: 700px;
        width: 375px;
    }



    #explanationmodal_table {
        width: 100%;
        border-spacing: 0px;
    }

    #explanation_modal {
        width: auto;
    }
       ::-webkit-scrollbar {
        width: 3px;
    }

    ::-webkit-scrollbar-track {
        -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
        background-color: #F5F5F5;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #000000;
    }
</style>
